//Replaces hyphens with spaces in a query parameter.
export const decodeQueryParam = (param) => {
  if (!param) return '';
  return param.replace(/-/g, ' ');
};

//Trims and replaces spaces with hyphens for URL encoding.

export const encodeQueryParam = (param) => {
  if (!param) return '';
  return param.trim().replace(/\s+/g, '-');
};

//Gets and decodes a query parameter value from URLSearchParams.
export const getDecodedParam = (searchParams, key) => {
  const raw = searchParams.get(key) || '';
  return decodeQueryParam(raw);
};
